import React, { useState, useContext } from 'react'
import { Container, Divider } from '@material-ui/core'
import { BrowserView, MobileView } from 'react-device-detect'
import FlexView from 'react-flexview/lib'
import {
  SessionContextStore,
  SESSION_ACTIONS,
} from '../../context/SessionContext'
import { UserApi } from '../../api/user.api'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import './UserProfile.css'
import Accordion from '@material-ui/core/Accordion'
import AccordionSummary from '@material-ui/core/AccordionSummary'
import AccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import { AddressSection } from './ProfileSections/AddressSection'
import { UserSection } from './ProfileSections/UserSection'
import { InsuranceTypeSection } from './ProfileSections/InsuranceTypeSection'
import { InsuranceHistorySection } from './ProfileSections/InsuranceHistorySection'
import { UserProfileContextStore } from '../../context/UserProfileContext'
import DoneIcon from '@material-ui/icons/Done'
import {
  isOver18,
  awaitWithLoading,
  convertToYesOrNo,
  isInPurchaseFlow,
} from '../../services/utils'
import { useLocation } from 'react-router-dom'
import { BackButton } from '../Core/Buttons/BackButton'
import { ContinueButton } from '../Core/Buttons/ContinueButton'
import { BottomSheetPolicySummary } from '../Insurance/BottomSheetPolicySummary'
import NewFillButton from '../Core/NewFillButton'
import { TextDivider } from '../Core/TextDivier'
import {
  FirebaseService,
  FirebaseConfigKey,
} from '../../services/FirebaseService'
import { SessionService } from '../../services/SessionService'
import DataLayerService from '../../services/DataLayerService'
import { GetAQuotePopup } from '../Quote/GetAQuotePopup'
import { Experiment, Variant } from 'react-optimize'
import { AdditionalAircraftsSection } from './ProfileSections/AdditionalAircraftsSection'
import { FormProvider, useForm } from 'react-hook-form'
import { ParentPopup } from '../PopUps/ParentPopup'
import { ERROR_CODES } from '../../models/errors/ErrorCodes'
import { useHistory } from 'react-router-dom'
import MailOutlineIcon from '@material-ui/icons/MailOutline'
import { COVERAGE_TYPES } from '../../models/insurance-models/CoverageType'
import { Action } from '../../models/Action'

var dayjs = require('dayjs')

export const UserProfile = (props) => {
  const location = useLocation()
  let sessionContext = useContext(SessionContextStore)
  const profileContext = useContext(UserProfileContextStore)
  const loginState = sessionContext.user.state
  const [showPasswordlessVerifyMsg, setShowPSVerifyMsg] = React.useState(false)
  const history = useHistory()
  const methods = useForm({
    defaultValues: { insurance_type: COVERAGE_TYPES.PERSONAL },
    mode: 'onChange',
  })
  const { setValue } = methods

  const existsPasswordlessLoginAttempt = (res) => {
    return (
      res &&
      !res.ok &&
      res.status == 400 &&
      res.data.code &&
      res.data.code == ERROR_CODES.PASSWORDLESS_USER_LOGIN_ATTEMPT_ERROR
    )
  }
  const userAlreadyExistsResponse = (res) => {
    return (
      res &&
      !res.ok &&
      res.status == 400 &&
      res.data.code &&
      res.data.code == ERROR_CODES.USER_ALREADY_EXISTS_ERROR
    )
  }

  const isUserInfoValid = () => {
    return profileContext.user_info.fname && profileContext.user_info.lname
  }
  const isAddressValid = () => {
    return (
      profileContext.address.address_line_1 &&
      profileContext.address.city &&
      profileContext.address.state != 'statedefault' &&
      profileContext.address.zipcode
    )
  }

  const isInsuranceTypeValid = () => {
    return profileContext.insurance_type.insurance_type
  }

  const save = async () => {
    let valid = await methods.trigger()
    if (!valid) return

    if (
      !isOver18(new Date(methods.getValues().dob)) &&
      !profileContext.user_parent_saved
    ) {
      EventEmitterService.dispatch(EventKey.SHOW_PARENT_POPUP)
      return
    }
    EventEmitterService.dispatch(EventKey.USER_PROFILE_SAVE)

    setTimeout(() => {
      var errElm = document.getElementsByClassName('Mui-error')
      if (errElm && errElm.length > 0) {
        var elementPosition = errElm[0].getBoundingClientRect().top
        var offsetPosition = elementPosition - 30
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        })
      }
    }, 300)
  }

  React.useEffect(() => {
    async function uploadProfileData() {
      let resRegister
      if (!SessionService.isLoggedIn()) {
        resRegister = await awaitWithLoading(
          sessionContext.registerPasswordless(
            profileContext.user_info.email,
            profileContext.insurance_type.insurance_type
          )
        )
      }

      if (SessionService.isLoggedIn() || resRegister.ok) {
        const values = {
          ...sessionContext.user,
          ...profileContext.user_info,
          ...profileContext.address,
          parent_info: profileContext.parent_info,
        }
        EventEmitterService.dispatch(EventKey.USER_STATE_CHANGED, values.state)
        let res = await awaitWithLoading(UserApi.saveProfile(values))
        profileContext.dispatch({ type: 'RESET' })

        if (!res.ok) {
          EventEmitterService.dispatch(EventKey.ShowError, res)
        } else {
          DataLayerService.pushToDataLayer({
            event: 'successful-profile-saved',
          })
          sessionContext.dispatch({
            type: SESSION_ACTIONS.UPDATE_USER_PROFILE,
            data: res.parsedData,
          })
          if (location.pathname == '/insurance/profile') {
            EventEmitterService.dispatch(
              EventKey.FLOW_PROFILE_FINISH,
              res.parsedData
            )
          } else if (location.pathname == '/account/profile') {
            EventEmitterService.dispatch(EventKey.ShowSuccess, {
              title: 'Profile saved successfully',
            })
          } else
            EventEmitterService.dispatch(EventKey.ShowSuccess, {
              title: 'Success!',
              body: 'Your details were sent to your broker',
            })
          window.clarityUpdateUserId(res.parsedData.email)
        }
      } else if (existsPasswordlessLoginAttempt(resRegister)) {
        setShowPSVerifyMsg(true)
        window.clarityUpdateUserId(profileContext.user_info.email)
      } else if (userAlreadyExistsResponse(resRegister)) {
        resRegister.data.title = 'You are already registered'
        EventEmitterService.dispatch(EventKey.ShowError, {
          res: resRegister,
          actionText: 'Login to Continue',
          onClose: () => {
            history.push('/login')
          },
        })
      } else {
        EventEmitterService.dispatch(EventKey.ShowError, resRegister)
      }
    }
    if (
      profileContext.user_info_saved &&
      profileContext.address_saved &&
      profileContext.insurance_type_saved &&
      isUserInfoValid() &&
      isAddressValid() &&
      isInsuranceTypeValid()
    ) {
      uploadProfileData()
    }
  }, [
    profileContext.user_info_saved,
    profileContext.insurance_type_saved,
    profileContext.address_saved,
    profileContext.address.zipcode,
  ])

  React.useEffect(() => {
    let id = EventEmitterService.subscribe(
      EventKey.SHOW_PARENT_POPUP_FINISH,
      async (values) => {
        profileContext.dispatch(new Action('SAVE_USER_PARENT', values))
      }
    )

    return function cleanup() {
      EventEmitterService.unsubscribe(EventKey.SHOW_PARENT_POPUP_FINISH, id)
    }
  }, [])

  const isInProfile = location.pathname == '/account/profile'
  const isInProposal = location.pathname == '/proposal/profile'

  return showPasswordlessVerifyMsg ? (
    <FlexView column hAlignContent={'center'}>
      <MailOutlineIcon className="x-large-icon blue" />
      <br />
      <div className="text-body textcenter">You are already registered</div>
      <div className="text-body textcenter">
        A link to verify your email has been sent to{' '}
        {profileContext.user_info.email}
      </div>
      <br />
      <div className="texy-body textcenter bold">
        Please check your email to continue
      </div>
      <br />
      <button
        onClick={() => history.push('/login')}
        className="texy-body textcenter bold">
        Go to login
      </button>
    </FlexView>
  ) : (
    <React.Fragment>
      {/* <BrowserView> */}
      <Container className="margin-top-medium">
        <FormProvider {...methods} formState>
          <div className="text-title blue bold">Applicant Details</div>
          <Divider />
          <div className="text-small-title black bold margin-bottom-basic">
            Personal details
          </div>
          <UserSection />
          <Divider />
          <div className="text-small-title black bold">Address</div>
          <AddressSection />
          <Divider />
          <div className="text-small-title black bold">Insurance Type</div>
          <InsuranceTypeSection />
          <Divider />
          <AdditionalAircraftsSection />
        </FormProvider>
        {/* <div className="text-small-title black bold">Insurance History</div> 
                    <InsuranceHistorySection /> */}
        {location.pathname == '/insurance/profile' && (
          <FlexView className="margin-top-small margin-bottom-basic">
            {/* <BackButton /> */}
            <ContinueButton onClick={save} />
            {/* <div className="margin-left-12">
                            {!location.pathname.startsWith('/proposal') && SessionService.isBroker() && <GetAQuotePopup />}
                        </div> */}
          </FlexView>
        )}
        {isInProfile && (
          <FlexView className="margin-top-small margin-bottom-basic">
            <NewFillButton onClick={save}>Save Changes</NewFillButton>
          </FlexView>
        )}
        {isInProposal && (
          <FlexView
            vAlignContent={'center'}
            className="margin-top-small margin-bottom-basic">
            <BackButton />
            <div className="margin-left-12">
              <NewFillButton onClick={save}>Send to broker</NewFillButton>
            </div>
          </FlexView>
        )}
      </Container>

      {/* </BrowserView>
            <MobileView>
                <Container maxWidth="lg" className="margin-top-medium">
                    <div className="margin-top-medium margin-bottom-medium">
                        <TextDivider><div className="text-title bold blue">Applicant Details</div></TextDivider>
                    </div>
                    <Accordion defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="text-title black">Personal Details</div>
                            {isUserInfoValid() && <DoneIcon className="green margin-left-6" />}
                        </AccordionSummary>
                        <AccordionDetails>
                            <UserSection />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="text-title black">Address</div>
                            {isAddressValid() && <DoneIcon className="green margin-left-6" />}
                        </AccordionSummary>
                        <AccordionDetails>
                            <AddressSection />
                        </AccordionDetails>
                    </Accordion>
                    <Accordion defaultExpanded>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <div className="text-title black">Insurance History</div>
                            {insuranceHistoryValid && <DoneIcon className="green margin-left-6" />}
                        </AccordionSummary>
                        <AccordionDetails>
                            <div>
                                <InsuranceHistorySection />
                            </div>
                        </AccordionDetails>
                    </Accordion>
                </Container>
                {location.pathname == '/insurance/profile' && <>
                    <FlexView className="margin-top-basic" hAlignContent={'right'}>
                        <ContinueButton onClick={save} />
                    </FlexView>
                </>}
                {isInProfile && <FlexView hAlignContent={'center'} className="margin-top-small margin-bottom-basic">
                    <NewFillButton onClick={save}>Save Changes</NewFillButton>
                </FlexView>}
                {isInProposal && <FlexView hAlignContent={'center'} className="margin-top-small margin-bottom-basic">
                    <NewFillButton onClick={save}>Send to broker</NewFillButton>
                </FlexView>}
            </MobileView> */}
      <ParentPopup />
    </React.Fragment>
  )
}
